import styled from 'styled-components';

const alertLabel = `
  font-size: 0.875rem;
  font-weight: 400;
  color: #6c677a;
  text-align: left;
  width: 297px;
  margin-top: 8px;
`;

export const Label = styled.label`
  font-size: 1.5rem;
  font-weight: 300;
  color: #6c677a;
  text-align: right;
  ${props => !!props.alert && alertLabel}
  ${props =>
    props.error &&
    `
      ${alertLabel}
      color: #FF1343;
  `}

  @media (max-width: 1500px) {
    display: flex;
    align-items: start;
    width: 100%;
    flex-direction: column;
  }
  
  @media (max-width: 960px) {
    text-align: left;
    width: 100%;
  }
`;

export const Select = styled.select`
  width: 297px;
  height: 30px;
  margin-left: 24px;
  background: transparent;
  border-width: 0 0 1px 0;
  border-color: #57435f;
  border-style: solid;
  color: #cdccd2;
  font-size: 1.125rem;
  font-weight: 300;
  outline: 0;

  > option {
    color: #000;
    background: #ffffff;
  }

  &::placeholder {
    opacity: 0.7;
  }

  ${props =>
    props.error &&
    `
    border-width: 0 0 0 0;
    box-shadow: 0 4px 2px -2px #FF1343;
    opacity: 1;
`}

  @media (max-width: 1500px) {
    width: 100%;
    margin: 0;
  }

  @media(max-width: 960px) {
    margin-left: 0;
    width: 100%;
  }
`;

export const Container = styled.div`
  margin-top: 42px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;

  & + div {
    margin-top: 42px;
  }

  @media (max-width: 1500px) {
    margin-left: 0;
    margin-right: 0;
  }

  @media (max-width: 960px) {
    margin: 10% 15% 0 15%;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;

  @media (max-width: 1500px) {
    width: 100%;
    flex-direction: column;
  }

  @media (max-width: 960px) {
    width: 100%;
  }
`;
